import {
	createLocalStorageProvider,
	createSessionExpirableStorageProvider,
} from '@atlassian/jira-browser-storage-providers';

const RETURN_TO_PROJECT_URL = 'returnToProjectUrl';

const sessionStorage = createSessionExpirableStorageProvider('navigation');

export const setReturnToProjectUrl = () => {
	sessionStorage.set(RETURN_TO_PROJECT_URL, window.location.pathname + window.location.search);
};

export const localStorage = createLocalStorageProvider('code_in_jira-code-page');
